export const FETCH_CANDIDATEFORM = 'FETCH_CANDIDATEFORM';
export const FETCH_CANDIDATEFORM_SUCCESS = 'FETCH_CANDIDATEFORM_SUCCESS';
export const FETCH_CANDIDATEFORM_FAILURE = 'FETCH_CANDIDATEFORM_FAILURE';

export const FETCH_CANDIDATEFORM_SUBMISSION = 'FETCH_CANDIDATEFORM_SUBMISSION';
export const FETCH_CANDIDATEFORM_SUBMISSION_SUCCESS = 'FETCH_CANDIDATEFORM_SUBMISSION_SUCCESS';
export const FETCH_CANDIDATEFORM_SUBMISSION_FAILURE = 'FETCH_CANDIDATEFORM_SUBMISSION_FAILURE';

export const CLEAR_CANDIDATEFORM_SUBMISSION = 'CLEAR_CANDIDATEFORM_SUBMISSION';

export const SET_FORM_SUBMISSION = 'SET_FORM_SUBMISSION';






